import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import newDesignSwitch from "@/mixins/newDesignSwitch";

export default {
    name: "profile-navigation",
    mixins: [newDesignSwitch],
    data() {
        return {};
    },
    created() {
        if (!this.certificates || this.certificates.length === 0) {
            this.fetchCertificates();
        }
    },
    computed: {
        ...mapGetters({
            user                : `user/user`,
            userTariff          : `user/userTariff`,
            
            certificates        : `userSertificates/list`,
            isListLoading       : `userSertificates/isListLoading`,
            
            userHomework        : `userHomework/list`,
            
            openNotification    : "userPayments/openNotification"
        }),
        imgAvatar() {
            if (this.user)
                return this.user.personalData.data.avatar !== ""
                    ? this.user.personalData.data.avatar
                    : require("@/assets/img/default-avatar.jpg");
            return require("@/assets/img/default-avatar.jpg");
        },
    },
    methods: {
        ...mapActions({
            fetchCertificates   : "userSertificates/GET_LIST",
            authLogout          : "auth/AUTH_LOGOUT",
        }),
        ...mapMutations({
            changeMenu          : "user/MOBILE_CHANGE_SHOW_MENU",
        }),
        calculateExpiredDate(item) {
            const { activeTo } = item;
            
            if (!activeTo) {
                return "∞";
            }
            
            return moment(activeTo).format("DD MMMM, YYYY");
        },
        logout() {
            this.authLogout();
            
            this.$router.push({ name: "sing-in" });
        },
    },
};
